import { LocaleEnum } from 'shared/enums/locale-enum'
import { BottomMenuItemInterface } from './bottom-menu-items'

const defaultBlogPage: BottomMenuItemInterface = {
  title: 'public.public_footer.resources.blog',
  href: '/blog',
}

const defaultResourcesMenuItems: BottomMenuItemInterface[] = [
  defaultBlogPage,
  {
    title: 'public.public_footer.resources.branding',
    href: '/branding',
  },
  {
    title: 'public.public_footer.resources.compare',
    href: '/compare',
  },
]

export const blogItems = {
  [LocaleEnum.ENGLISH]: [
    ...defaultResourcesMenuItems,
    {
      title: 'public.public_footer.resources.public_api',
      href: 'https://help.systeme.io/article/2329-how-to-use-systeme-io-public-api',
    },
  ],
  [LocaleEnum.FRENCH]: [
    ...defaultResourcesMenuItems,
    {
      title: 'public.public_footer.resources.public_api',
      href: 'https://aide.systeme.io/article/2328-comment-utiliser-api-publique-de-systemeio',
    },
  ],
  [LocaleEnum.SPANISH]: [
    ...defaultResourcesMenuItems,
    {
      title: 'public.public_footer.resources.public_api',
      href: 'https://help-es.systeme.io/article/2337-como-usar-la-clave-api-publica-de-systeme-io',
    },
  ],
  [LocaleEnum.ITALIAN]: [
    ...defaultResourcesMenuItems,
    {
      title: 'public.public_footer.resources.public_api',
      href: 'https://help-it.systeme.io/article/2345-come-utilizzare-lapi-pubblica-di-systeme-io',
    },
  ],
  [LocaleEnum.PORTUGUESE]: [
    ...defaultResourcesMenuItems,
    {
      title: 'public.public_footer.resources.public_api',
      href: 'https://help-pt.systeme.io/article/2339-como-usar-a-api-publica-da-systeme-io',
    },
  ],
  [LocaleEnum.DEUTSCH]: [
    defaultBlogPage,
    {
      title: "Systeme.io's Logo-Dateien",
      href: '/logo',
    },
    {
      title: 'public.public_footer.resources.compare',
      href: '/compare',
    },
  ],
  [LocaleEnum.DUTCH]: [],
  [LocaleEnum.RUSSIAN]: [
    defaultBlogPage,
    { title: 'Как заработать деньги дома', href: '/blog/make-money-home' },
    { title: 'Краткое описание стартапа за $100', href: '/blog/the-100-startup' },
    {
      title: 'Как заработать деньги в социальных сетях',
      href: '/blog/make-money-social-media',
    },
  ],
  [LocaleEnum.JAPANESE]: [
    {
      title: 'Systeme.ioロゴファイル',
      href: '/logo',
    },
    {
      title: 'public.public_footer.resources.public_api',
      href: 'https://help-it.systeme.io/article/2345-come-utilizzare-lapi-pubblica-di-systeme-io',
    },
  ],
  [LocaleEnum.CHINESE]: [
    {
      title: 'Systeme.io logo dosyaları',
      href: '/logo',
    },
    {
      title: 'public.public_footer.resources.public_api',
      href: 'https://help-zh.systeme.io/article/3299-how-to-use-systeme-ios-public-api',
    },
  ],
  [LocaleEnum.TURKISH]: [
    {
      title: 'Systeme.io logo dosyaları',
      href: '/logo',
    },
    {
      title: 'public.public_footer.resources.compare',
      href: 'https://systeme.io/tr-compare',
    },
    {
      title: 'public.public_footer.resources.public_api',
      href: 'https://help-tr.systeme.io/article/3754-systeme-io-nun-halka-acik-api-i-nasil-kullanilir',
    },
  ],
  [LocaleEnum.ARABIC]: [
    {
      title: 'أصول العلامة التّجارية',
      href: '/logo',
    },
    {
      title: 'public.public_footer.resources.public_api',
      href: 'https://help-ar.systeme.io/article/2808-api-systeme-io',
    },
  ],
  [LocaleEnum.SWEDISH]: [
    ...defaultResourcesMenuItems,
    {
      title: 'public.public_footer.resources.public_api',
      href: 'https://help.systeme.io/article/2329-how-to-use-systeme-io-public-api',
    },
  ],
  [LocaleEnum.ROMANIAN]: [],
  [LocaleEnum.CZECH]: [],
  [LocaleEnum.HUNGARIAN]: [],
  [LocaleEnum.SLOVAK]: [],
  [LocaleEnum.DANISH]: [],
  [LocaleEnum.INDONESIAN]: [],
  [LocaleEnum.POLISH]: [],
  [LocaleEnum.GREEK]: [],
  [LocaleEnum.SERBIAN]: [],
  [LocaleEnum.HINDI]: [],
  [LocaleEnum.NORWEGIAN]: [],
  [LocaleEnum.THAI]: [],
  [LocaleEnum.SLOVENIAN]: [],
  [LocaleEnum.UKRAINIAN]: [],
  [LocaleEnum.ALBANIA]: [],
} as const satisfies Record<LocaleEnum, BottomMenuItemInterface[]>
